export default __webpack_public_path__ + "static/media/cube.1ae131dd.svg";